const baseUrl = import.meta.env.VITE_API_URL
const filesUrl = import.meta.env.VITE_FILES_URL
const manifestUrl = import.meta.env.VITE_MANIFEST_URL
const environment = import.meta.env.VITE_ENVIRONMENT
const gtag = import.meta.env.VITE_GTAG

export const LEADERBOARD_BATCH_SIZE = import.meta.env.VITE_LB_BATCH_SIZE
export const LEADERBOARD_MAX_PAGE = 10
export { filesUrl, manifestUrl, environment, gtag, baseUrl }
